import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import Select from 'react-select';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import PaginationC from './pagination';
import Loader from './Loader/Loader';
import camera from '../assets/images/svg/camera.svg';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';

const Product = (props) => {

  const imageRef = useRef();

  const typeName = [
    { value: 'side1', label: 'Side1' },
    { value: 'side2', label: 'Side1' },
    { value: 'top', label: 'Top' },
    { value: 'top_lg', label: 'Top LG' },
  ];

  const caratData = [
    { carat: 0.33, carat_name: '1/3' },
    { carat: 0.5, carat_name: '1/2' },
    { carat: 0.75, carat_name: '3/4' },
    { carat: 1, carat_name: '1' },
    { carat: 1.25, carat_name: '1 1/4' },
    { carat: 1.5, carat_name: '1 1/2' },
    { carat: 2, carat_name: '2' },
    { carat: 2.5, carat_name: '2 1/2' },
    { carat: 2.25, carat_name: '2 1/4' },
    { carat: 2.75, carat_name: '2 3/4' },
    { carat: 3, carat_name: '3' },
    { carat: 4, carat_name: '4' },
    { carat: 5, carat_name: '5' },
  ];

  const [modalShow, setModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true)
  const [shapeData, setShapeData] = useState([])
  const [states, setStates] = useState({})
  const [productList, setProductList] = useState([])
  const [mode, setMode] = useState();

  const serverURL = getServerURL()
  const [data, setData] = useState([])
  const [paginationData, setPaginationData] = useState({})
  const [page, setPage] = useState(1)
  const [subLoader, setSubLoader] = useState(false)

  useEffect(() => {
    if (searchText?.length) setPage(1);
  }, [searchText]);

  useEffect(() => {
    getAllProduct();
  }, [searchText, page]);

  useEffect(() => {
    if (!mode && states?.product_id) {
      getProductShape(states?.product_id)
    }
  }, [states?.product_id]);

  const getAllProduct = (event) => {
    api.getWithToken(`${serverURL}create-product/product-carat-image/?page=${page}${searchText && `&_i=${searchText}`}`)
      .then(async (res) => {
        const { data, links, page, page_size, total, total_pages } = res?.data;
        setPaginationData({ links, page, page_size, total, total_pages })
        setLoading(false)
        if (res?.data?.success === true) {
          setData(data);
        }
      })
      .catch((e) => {
        setLoading(false)
      });
  };

  useEffect(() => {
    getFilterProductList()
  }, []);

  useEffect(() => {
    if (states?.carat) {
      const caratObj = caratData?.find(item => item.carat === parseFloat(states?.carat));
      setStates({
        ...states,
        carat_name: caratObj ? caratObj.carat_name : "",
      });
    }
  }, [states?.carat])

  const getProductShape = (id) => {
    api.getWithToken(`${serverURL}create-product/product-shapes/${id}`)
      .then(async (res) => {
        const { data } = res?.data;
        if (res?.data?.success === true) {
          setShapeData(data?.map(item => ({ value: item.shape_slug, label: item.shape })));
        }
      })
      .catch((e) => {
      });
  };

  const getFilterProductList = (type, subType) => {
    api.getWithToken(`${serverURL}create-product/search-filter/?_t=engagement-rings`)
      .then(async (res) => {
        setProductList(res?.data?.data?.map(item => ({ value: item?.id, label: item?.full_name })));
      })
      .catch((e) => {
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      const file = e.target.files[0];
      if (file) {
        setStates({
          ...states,
          [name]: file,
        });
      }
    } else
      setStates((prevValues) => ({
        ...prevValues,
        [name]: value.trimStart(),
      }));
  };

  const handleSubmit = (event) => {

    if (!states?.product_id) {
      toast.error('Please select product name');
      return
    }
    if (!states?.shape_slug) {
      toast.error('Please select shape name');
      return
    }
    if (!states?.type_name) {
      toast.error('Please select type name');
      return
    }
    if (!states?.carat) {
      toast.error('Please enter carat');
      return
    }
    if (!states?.carat_name) {
      toast.error('Please select carat name');
      return
    }
    if (!states?.image) {
      toast.error('Please select carat image');
      return
    }

    const formData = new FormData();

    formData.append('product_id', states.product_id);
    formData.append('shape_slug', states.shape_slug);
    formData.append('type_name', states.type_name);
    formData.append('carat', states.carat);
    formData.append('carat_name', states.carat_name);
    formData.append('image', states.image);

    const type = Boolean(mode) ? "postWithToken" : "putWithToken";

    api[type](`${serverURL}create-product/product-carat-image/${states?.id ? states?.id + "/" : ""}`, formData)
      .then(async (res) => {
        setModalShow(false)
        getAllProduct();
        if (res?.data?.success === true) {
          toast.success(res?.data?.message);
        } else if (res?.data?.success === false) {
          if (typeof res?.data?.message === "string")
            toast.error(res?.data?.message);
        }
      })
      .catch((e) => {
        errorResponse(e);
      });
  };

  const handleClick = (tet) => {
    imageRef.current.click();
  };

  const deleteProductShape = () => {
    api.deleteWithToken(`${serverURL}create-product/product-carat-image/${deleteData}`)
      .then(async (res) => {
        getAllProduct();
        setDeleteModalShow(false)
        if (res?.data?.success === true) {
          toast.success(res?.data?.message);
        } else if (res?.data?.success === false) {
          if (typeof res?.data?.message === "string")
            toast.error(res?.data?.message);
        }
      })
      .catch((e) => {
        errorResponse(e);
      });
  };

  return (
    <>
      <Card className="user-list">
        <Card.Header>
          <div className='d-flex justify-content-between align-items-center'>
            <Card.Title as="h4">{props?.title || ""}</Card.Title>
            <div className='d-flex align-items-center'>
              <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
              <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({}); setModalShow(true) }}>
                {"Add"}
              </Button>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table responsive hover className='product-table'>
            <thead>
              <tr>
                <th>No</th>
                <th>Image</th>
                <th>Product Shape</th>
                <th>Type Name</th>
                <th>Carat</th>
                <th>Carat Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Boolean(loading) ?
                <tr>
                  <td colSpan={6} className='text-center'>
                    <Loader loading={loading} />
                  </td>
                </tr>
                :
                Boolean(data?.length) ? data?.map((item, index) =>
                  <tr key={index + "productAll"}>
                    <td>{(10 * (page - 1)) + (index + 1)}</td>
                    <td>
                      <img className="rounded-circle" style={{ width: '100%', maxWidth: "40px", height: "40px" }} src={item?.image} alt="activity-user" />
                    </td>
                    <td>
                      <h6 className="m-0">{item?.product_shape || "-"} </h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.type_name || "-"} </h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.carat || "-"} </h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.carat_name || "-"} </h6>
                    </td>

                    <td>
                      <div className='d-flex align-items-center gap-3'>
                        <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setModalShow(true) }}>
                          <i className="feather icon-edit" title='Edit' />
                        </div>
                        <div className='cursor-pointer' onClick={() => { setDeleteData(item?.id); setDeleteModalShow(true) }}>
                          <i className="feather icon-trash-2" title='Delete' />
                        </div>
                      </div>
                    </td>
                  </tr>
                )
                  :
                  <tr>
                    <td colSpan={7} className='text-center'>
                      There are no records available at the moment.
                    </td>
                  </tr>
              }

            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {Boolean(data?.length) && paginationData?.total_pages > 1 &&
        <PaginationC data={paginationData}
          onPageChange={(newPage) => {
            setPage(newPage);
          }} />
      }

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center'>
              <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body>
              {Boolean(subLoader) && <Loader loading={subLoader} />}
              <Form.Group className="mb-3 align-items-end mt-3" as={Row} controlId="formHorizontalName">
                <Form.Label column sm={5}>
                  Select Product Name
                </Form.Label>
                <Select
                  value={productList.find(option => option.value === states?.product_id)}
                  onChange={(selectedOption) => {
                    setStates((prev) => ({
                      ...prev,
                      product_id: selectedOption?.value
                    }));
                    getProductShape(selectedOption?.value)
                  }
                  }
                  options={productList}
                  placeholder={"Select product name"}
                />
              </Form.Group>

              <Form.Group className="mb-3" as={Row} controlId="formHorizontalDisplayName">
                <Form.Label column sm={5}>
                  Select Shape
                </Form.Label>
                <Select
                  value={shapeData.find(option => option.value === states?.shape_slug)}
                  defaultValue={states?.shape_slug}
                  onChange={(selectedOption) =>
                    setStates((prev) => ({
                      ...prev,
                      shape_slug: selectedOption?.value
                    }))
                  }
                  options={shapeData}
                />
              </Form.Group>

              <Form.Group className="mb-3" as={Row} controlId="formHorizontalDisplayName">
                <Form.Label column sm={5}>
                  Select type name
                </Form.Label>
                <Select
                  value={typeName.find(option => option.value === states?.type_name)}
                  onChange={(selectedOption) =>
                    setStates((prev) => ({
                      ...prev,
                      type_name: selectedOption?.value
                    }))
                  }
                  options={typeName}
                />
              </Form.Group>

              <Form.Group className="mb-3" as={Row} controlId="formHorizontalName">
                <Form.Label column sm={3}>
                  Carat
                </Form.Label>
                <Form.Control type="text" placeholder="Enter carat" value={states.carat} name="carat" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3" as={Row} controlId="formHorizontalName">
                <Form.Label column sm={3}>
                  Carat Name
                </Form.Label>
                <Form.Control type="text" placeholder="Enter carat name" value={states.carat_name} name="carat_name" onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3 d-flex align-items-center" as={Row} controlId="formHorizontalCheck">
                <Form.Label as="legend" column lg={2} className='mb-0'>
                  Image
                </Form.Label>
                <div className="position-relative profile-image" id="profile_image">
                  <div className="d-flex">
                    {states?.image && <img
                      src={states?.image.size ? URL.createObjectURL(states?.image) : states?.image}
                      onClick={() => handleClick()}
                      className={`cursor-pointer upload-image`}
                      alt={`uploaded`}
                      style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    }
                  </div>
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png, webm, .webp"
                    name="image"
                    style={{ display: "none" }}
                    ref={imageRef}
                    onChange={handleChange}
                  />
                  <img
                    onClick={() => handleClick()}
                    src={camera}
                    className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                    width={30}
                    height={30}
                  />
                </div>
              </Form.Group>

              <div className='d-flex justify-content-end'>
                <Button type='button' onClick={() => handleSubmit()} className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      {/* Delete */}
      <Modal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {Boolean(subLoader) && <Loader loading={subLoader} />}
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
              <Card.Title as="h5">Delete {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body className='pb-2'>
              <h6>Are you sure you want to delete?</h6>
              <div className='d-flex justify-content-center'>
                <Button onClick={() => deleteProductShape()} className='mt-3 mb-0 mx-0'>Delete</Button>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Product